import $axios from "@/api";

const state = () => ({
  dataDKImport: {
    data: [],
    headers: [],
  },
});

const mutations = {
  ASSIGN_DK_IMPORT(state, payload) {
    state.dataDKImport = payload;
  },
};

const actions = {
  async checkDKSTTImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/stt_check", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async recheckDKSTTImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/stt_recheck", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async saveDKSTTBatch({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/stt_save", payload);
       commit("ASSIGN_DK_IMPORT", {
         data: [],
         headers: [],
       });
    } catch (err) {
      console.log(err);
    }
  },
  async checkDKSTDImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/std_check", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async recheckDKSTDImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/std_recheck", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async saveDKSTDBatch({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/std_save", payload);
       commit("ASSIGN_DK_IMPORT", {
         data: [],
         headers: [],
       });
    } catch (err) {
      console.log(err);
    }
  },
  async checkDKReturImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/retur_check", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async recheckDKReturImport({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/retur_recheck", payload);
      commit("ASSIGN_DK_IMPORT", response.data);
    } catch (err) {
      console.log(err);
    }
  },
  async saveDKReturBatch({ commit }, payload) {
    try {
      const response = await $axios.post("external_app/dk/retur_save", payload);
       commit("ASSIGN_DK_IMPORT", {
         data: [],
         headers: [],
       });
    } catch (err) {
      console.log(err);
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
